<div class="top-section">
    <h6 class="heading mb-0">{{ policyTitle() }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="body-section">
    <div class="policy-iframe-container">
        @if (isLoading()) {
            <div class="loading-spinner"></div>
        }
        <iframe
            [src]="policyUrl()"
            (load)="onIframeLoad()"
            class="policy-iframe"
            [class.hidden]="isLoading()"
            frameborder="0"
            [title]="ss.t('dialog_policyTitle')">
        </iframe>
    </div>
</div>